import { render, staticRenderFns } from "./QuickCheckin.vue?vue&type=template&id=67f6e0b4&"
import script from "./QuickCheckin.vue?vue&type=script&lang=js&"
export * from "./QuickCheckin.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports